
import { Vue, Component, Ref, Prop } from 'vue-property-decorator';
import ExamineModal from './common/ExamineModal.vue';
import lazyInject from '@/di';
import WithdrawService from '@/services/withdraw.service';
import RejectModal from './common/RejectModal.vue';
import { WithdrawExamineStatus } from '@/common/enum/withdraw';
import { IApply } from '@/common/interface/apply';
import { CApply } from '@/models/apply.model';
import { AuthEnum } from '@/services/permission.service';
import UTILService from '@/services/utils.service';

@Component({
  components: {
    'examine-modal': ExamineModal,
    'reject-modal': RejectModal,
  },
})
export default class ExaminDetail extends Vue {
  @lazyInject(WithdrawService)
  withdrawService!: WithdrawService;

  @lazyInject(UTILService)
  utilService!: UTILService;

  AuthEnum = AuthEnum;
  WithdrawExamineStatus = WithdrawExamineStatus;

  encryptAccount = '';

  visible = false;

  encryptAccountPhoone = '';

  selectedRowKeys: any = []; // Check here to configure the default column

  @Ref('examineModal')
  examineModal?: ExamineModal;

  @Ref('rejectModal')
  rejectModal?: RejectModal;

  withdrawAccount = '';

  loading = true;

  spin_loading = false;

  aLoading = true;

  withdrawAmount = '0.00';

  status = '0';

  columns = [
    {
      title: '序号',
      dataIndex: 'id',
      scopedSlots: { customRender: 'index' },
      align: 'center',
      width: 80,
    },
    {
      title: '高德订单号',
      dataIndex: 'orderNo',
      align: 'center',
      width: 260,
    },
    {
      title: '门店名称',
      dataIndex: 'shopName',
      align: 'center',
      width: 200,
    },
    {
      title: 'SKU',
      dataIndex: 'goodsId',
      align: 'center',
      width: 100,
    },
    {
      title: '商品名称',
      dataIndex: 'goodsName',
      align: 'center',
      width: 200,
    },
    {
      title: '品牌',
      dataIndex: 'kaName',
      align: 'center',
      width: 100,
    },
    {
      title: '数量',
      dataIndex: 'quantity',
      align: 'center',
      width: 100,
    },
    {
      title: '总核销次数',
      dataIndex: 'tnum',
      align: 'center',
      width: 110,
    },
    {
      title: '核销次数',
      dataIndex: 'cnum',
      align: 'center',
      width: 100,
    },
    {
      title: '下单时间',
      dataIndex: 'ctime',
      align: 'center',
      width: 120,
    },
    {
      title: '订单金额',
      dataIndex: 'oriPrice',
      align: 'center',
      width: 100,
    },
    {
      title: '优惠金额',
      dataIndex: 'coupon',
      align: 'center',
      width: 100,
    },
    {
      title: '实收金额',
      dataIndex: 'price',
      align: 'center',
      width: 100,
    },
    {
      title: '抽拥比例',
      dataIndex: 'comRatio',
      align: 'center',
      width: 100,
    },
    {
      title: '抽拥金额',
      dataIndex: 'commissionPrice',
      align: 'center',
      width: 100,
    },
    {
      title: '结算金额',
      dataIndex: 'verifyPrice',
      align: 'center',
      width: 100,
    },
    // {
    //   title: '核销状态',
    //   dataIndex: 'verity_status',
    //   align: 'center',
    //   width: 100,
    // },
    {
      title: '核销时间',
      dataIndex: 'verifyts',
      align: 'center',
      width: 120,
    },
    // {
    //   title: '结算状态',
    //   dataIndex: 'settle_status',
    //   align: 'center',
    //   width: 100,
    // },
  ];
  columnsTitle: any[] = [];
  columnsTitleAdd = [
    {
      title: '序号',
      dataIndex: 'id',
      scopedSlots: { customRender: 'index' },
      align: 'center',
      width: 80,
    },
    {
      title: '转账单号',
      dataIndex: 'transfer_no',
      align: 'center',
      width: 240,
    },
    {
      title: '转账时间',
      dataIndex: 'created_at',
      align: 'center',
      width: 200,
    },
    {
      title: '支付宝订单号',
      dataIndex: 'pay_order_no',
      align: 'center',
      width: 200,
    },
    {
      title: '支付宝流水号',
      dataIndex: 'pay_flow_no',
      align: 'center',
      width: 200,
    },
    {
      title: '转账金额',
      dataIndex: 'amount',
      align: 'center',
      width: 200,
    },
    {
      title: '转账状态',
      dataIndex: 'status',
      align: 'center',
      width: 200,
      scopedSlots: { customRender: 'status' },
    },
    {
      title: '失败原因',
      dataIndex: 'fail_remark',
      align: 'center',
      width: 200,
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      scopedSlots: { customRender: 'action' },
      width: 110,
    },
  ];
  columnsTitleEdit = [
    {
      title: '序号',
      dataIndex: 'id',
      scopedSlots: { customRender: 'index' },
      align: 'center',
      width: 80,
    },
    {
      title: '提现单号',
      dataIndex: 'transfer_no',
      align: 'center',
      width: 240,
    },
    {
      title: '转账时间',
      dataIndex: 'created_at',
      align: 'center',
      width: 200,
    },
    {
      title: '支付宝订单号',
      dataIndex: 'pay_order_no',
      align: 'center',
      width: 200,
    },
    {
      title: '支付宝流水号',
      dataIndex: 'pay_flow_no',
      align: 'center',
      width: 200,
    },
    {
      title: '转账金额',
      dataIndex: 'amount',
      align: 'center',
      width: 200,
    },
    {
      title: '转账状态',
      dataIndex: 'status',
      align: 'center',
      width: 200,
      scopedSlots: { customRender: 'status' },
    },
    {
      title: '失败原因',
      dataIndex: 'fail_remark',
      align: 'center',
      width: 200,
    },
  ];

  dataEr = [];
  withdrawalAccountName = '';

  @Prop()
  typeSource?: string;

  logData = [];

  pagination = {
    total: 0,
    pageSize: 10,
    current: 1,
    onChange: this.paginationChange,
    showTotal: (total: any) => `共 ${total} 条`,
  };

  formDate = {
    id: '',
    no: '',
  };

  data = [];

  examineFun() {
    this.examineModal?.open(this.formDate.id);
  }
  back() {
    if (this.$route.params.type === 'detail') {
      this.$router.push({
        name: 'withdraw.AuditDetails',
      });
    } else {
      this.$router.push({
        name: 'withdraw.examine',
      });
    }
  }

  open(id: string, no: string) {
    this.visible = true;
    this.formDate.id = id;
    this.formDate.no = no;
    this.getDetail();
    if (this.typeSource === 'detail') {
      this.columnsTitle = this.columnsTitleEdit;
    } else {
      this.columnsTitle = this.columnsTitleAdd;
    }
  }

  close() {
    this.visible = false;
    this.formDate = {
      id: '',
      no: '',
    };
    this.columnsTitle = [];
    this.data = [];
    this.dataEr = [];
    this.logData = [];
    this.withdrawAccount = '';
    this.withdrawAmount = '0.00';
    this.withdrawalAccountName = '';
    this.status = '0';
    this.$emit('refresh', true);
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getOrderList({
      wid: this.formDate.id,
      page,
      pageSize,
    });
  }

  onChangeData() {}
  onSelect() {}
  onSelectAll() {}
  getCheckboxProps() {}

  handleRowChange() {}

  refresh() {}

  examine() {
    // this.examineModal?.open();
    this.$confirm({
      title: '转账',
      content: '确定要转账吗？',
      onOk: async () => {
        const { id } = this.$route.params;
        const params = {
          wid: id,
          status: 1,
          verify: 'repeat',
        };
        const res = await this.withdrawService.verifyWithdrawalOrder(params);
        if (res) {
          this.$message.success('操作成功');
          this.getDetail();
        }
      },
    });
  }

  created() {
    // console.log(this.$route.params.id);
  }

  getColor(status: string) {
    // const statusEnum = WithdrawExamineStatus[status as keyof typeof WithdrawExamineStatus];
    let color: any = 'blue';
    switch (Number(status)) {
      case WithdrawExamineStatus.提现中: {
        color = '#bb0';
        break;
      }
      case WithdrawExamineStatus.转账失败: {
        color = 'red';
        break;
      }
      case WithdrawExamineStatus.待审核: {
        color = 'blue';
        break;
      }
      case WithdrawExamineStatus.提现成功: {
        color = 'green';
        break;
      }
      case WithdrawExamineStatus.审核未通过: {
        color = 'red';
        break;
      }
      default: {
        break;
      }
    }
    return color;
  }

  getDetail() {
    const { id } = this.formDate;
    // const no = this.$route.params.no;
    const params = {
      wid: id,
      page: 1,
      pageSize: 10,
    };
    this.getOrderList(params);
    this.getLog(id);
  }

  async getLog(params: any) {
    this.spin_loading = false;
    const res = await this.withdrawService.withdrawalOperateLog(params);
    if (res) {
      this.spin_loading = true;
      this.logData = res;
    }
  }

  async LookShopDetail(title: string, encryptAccount: string) {
    const data = {
      encrypt_phone: encryptAccount,
      operate_type: title,
    };
    // console.log(data);
    try {
      const res = await this.utilService.postPhoneDecrypt(data);
      if (res) {
        this.encryptAccountPhoone = res;
      }
    } catch (error) {
      this.$message.error('解密失败');
    }
  }

  async getOrderList(params: any) {
    const res = await this.withdrawService.withdrawalDetail(params);
    if (res) {
      this.loading = false;
      const applyList = res.list.map((item: IApply) => CApply.from(item));
      this.data = applyList;
      this.pagination.total = res.total;
      this.withdrawAccount = res.withdrawal_info.account;
      this.withdrawAmount = res.withdrawal_info.money;
      this.withdrawalAccountName = res.withdrawal_info.name;
      this.status = res.withdrawal_info.status;
      this.encryptAccount = res.withdrawal_info.encrypt_account;
      this.transferList(params.wid);
    }
  }

  async transferList(wid: number) {
    try {
      const res = await this.withdrawService.transferList(wid);
      // console.log(res);
      this.dataEr = res;
      this.aLoading = false;
    } catch (error) {
      // console.log(error);
      this.aLoading = false;
    }
  }
  reject() {
    this.rejectModal?.open(this.formDate.id);
    // this.examineModal?.open();
  }
  // mounted() {
  //   this.getDetail();
  //   const { type } = this.$route.params;
  //   console.log(type);
  //   if (type === 'detail') {
  //     this.columnsTitle.pop();
  //   }
  // }

  reTransfer(orderNo: any) {
    // console.log(orderNo);
    this.$confirm({
      title: '重新转账',
      content: '确定要重新转账吗？',
      onOk: async () => {
        const res = await this.withdrawService.reTransfer(orderNo.transfer_no);
        if (res) {
          this.$message.success('操作成功');
          this.getDetail();
        }
      },
    });
  }
  offlineTransfer() {
    this.$confirm({
      title: '线下转账',
      content: '确定要重新线下转账吗？',
      onOk: async () => {
        const params = {
          wid: this.formDate.id,
        };
        const res = await this.withdrawService.postEditByManual(params);
        if (res) {
          this.$message.success('操作成功');
          this.getDetail();
        }
      },
    });
  }
}
